import React, { createContext, useContext, useState, useCallback } from 'react';

const ConsultationModalContext = createContext(null);

export const CONSULTATION_TYPES = {
    general: {
        title: "Get in Touch",
        subtitle: "General Inquiry",
        description: "Our team will respond promptly with the appropriate technical or commercial contact.",
        buttonText: "Submit Inquiry"
    },
    demo: {
        title: "Request a Demo",
        subtitle: "See EverestCloud in Action",
        description: "Schedule a personalized demo with our solutions team.",
        buttonText: "Request Demo"
    },
    security_assessment: {
        title: "Security Assessment",
        subtitle: "Enterprise Security Review",
        description: "Request a comprehensive security assessment from our certified architects.",
        buttonText: "Request Assessment"
    },
    compliance_review: {
        title: "Compliance Review",
        subtitle: "Regulatory Alignment Check",
        description: "Our compliance experts will review your requirements.",
        buttonText: "Request Review"
    },
    architecture_walkthrough: {
        title: "Architecture Walkthrough",
        subtitle: "Deep Dive into EverestCloud",
        description: "See how EverestCloud protects your most critical workloads.",
        buttonText: "Request Walkthrough"
    },
    migration_consultation: {
        title: "Migration Consultation",
        subtitle: "Seamless Cloud Migration",
        description: "Talk to our migration experts about moving your workloads.",
        buttonText: "Request Consultation"
    },
    architecture_review: {
        title: "Architecture Review",
        subtitle: "Expert Infrastructure Analysis",
        description: "Get expert guidance on your cloud architecture design.",
        buttonText: "Request Review"
    },
    get_started: {
        title: "Get Started",
        subtitle: "Begin Your Cloud Journey",
        description: "Let us help you transform your infrastructure.",
        buttonText: "Get Started"
    }
};

export const ConsultationModalProvider = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [consultationType, setConsultationType] = useState('general');

    const openModal = useCallback((type = 'general') => {
        setConsultationType(type);
        setIsOpen(true);
    }, []);

    const closeModal = useCallback(() => {
        setIsOpen(false);
    }, []);

    return (
        <ConsultationModalContext.Provider value={{ isOpen, consultationType, openModal, closeModal }}>
            {children}
        </ConsultationModalContext.Provider>
    );
};

export const useConsultationModal = () => {
    const context = useContext(ConsultationModalContext);
    if (!context) {
        throw new Error('useConsultationModal must be used within a ConsultationModalProvider');
    }
    return context;
};
